import * as yup from "yup";
import { mobileNoOptional } from '../utils/phoneValidation';

const merchantSchemaStep1 = yup.object().shape({
  // ── Identity ────────────────────────────────────────────────────────────────
  recIdentifier: yup
    .string()
    .required("REC Identifier is required")
    .length(1, "Must be exactly 1 character"),

  institutionNumber: yup
    .string()
    .required("Institution Number is required")
    .matches(/^[0-9]{8}$/, "Must be exactly 8 digits"),

  clientNumber: yup
    .string()
    .required("Client Number is required")
    .matches(/^[0-9]{8}$/, "Must be exactly 8 digits"),

  registrationNumber: yup
    .string()
    .required("Registration Number is required")
    .max(20, "Max 20 characters"),

  // ── Business ────────────────────────────────────────────────────────────────
  companyName: yup.string().required("Company Name is required").max(60, "Max 60 characters"),

  tradeName: yup.string().required("Trade Name is required").max(40, "Max 40 characters"),

  businessClass: yup
    .string()
    .required("Business Class is required")
    .matches(/^[0-9]{4}$/, "Must be a 4-digit code"),

  // ── Processing ──────────────────────────────────────────────────────────────
  product: yup.string().required("Product is required").max(3, "Max 3 characters"),

  conditionSet: yup
    .string()
    .required("Condition Set is required")
    .matches(/^[0-9]{3}$/, "Must be 3 digits"),

  clientBranch: yup.string().max(3, "Max 3 characters"),

  mid: yup.string().required("MID is required").max(15, "Max 15 characters"),

  groupMid: yup.string().max(15, "Max 15 characters"),

  // ── Address ─────────────────────────────────────────────────────────────────
  addressLine1: yup.string().required("Address Line 1 is required").max(40, "Max 40 characters"),

  addressLine2: yup.string().max(35, "Max 35 characters"),

  addressLine3: yup.string().max(35, "Max 35 characters"),

  city: yup.string().required("City is required").max(35, "Max 35 characters"),

  postCode: yup
    .string()
    .required("Post Code is required")
    .max(10, "Max 10 characters"),

  // ── Contact ─────────────────────────────────────────────────────────────────
  contactName: yup.string().max(35, "Max 35 characters"),

  mobileNo: mobileNoOptional(),

  emailId: yup
    .string()
    .email("Invalid email address")
    .max(30, "Max 30 characters")
    .nullable()
    .transform((v) => (v === "" ? null : v)),
});

const merchantSchemaStep2 = yup.object().shape({
  bankAccount: yup.string().max(16, "Max 16 characters"),
  bankName: yup.string().max(100, "Max 100 characters"),
  ifscCode: yup.string().max(15, "Max 15 characters"),
});

const merchantSchema = yup.object().shape({
  // ── Identity ────────────────────────────────────────────────────────────────
  recIdentifier: yup
    .string()
    .required("REC Identifier is required")
    .length(1, "Must be exactly 1 character"),

  institutionNumber: yup
    .string()
    .required("Institution Number is required")
    .matches(/^[0-9]{8}$/, "Must be exactly 8 digits"),

  clientNumber: yup
    .string()
    .required("Client Number is required")
    .matches(/^[0-9]{8}$/, "Must be exactly 8 digits"),

  registrationNumber: yup
    .string()
    .required("Registration Number is required")
    .max(20, "Max 20 characters"),

  // ── Business ────────────────────────────────────────────────────────────────
  companyName: yup
    .string()
    .required("Company Name is required")
    .max(60, "Max 60 characters"),

  tradeName: yup
    .string()
    .required("Trade Name is required")
    .max(40, "Max 40 characters"),

  businessClass: yup
    .string()
    .required("Business Class is required")
    .matches(/^[0-9]{4}$/, "Must be a 4-digit code"),

  // ── Processing ──────────────────────────────────────────────────────────────
  product: yup
    .string()
    .required("Product is required")
    .max(3, "Max 3 characters"),

  conditionSet: yup
    .string()
    .required("Condition Set is required")
    .matches(/^[0-9]{3}$/, "Must be 3 digits"),

  clientBranch: yup
    .string()
    .max(3, "Max 3 characters"),

  mid: yup
    .string()
    .required("MID is required")
    .max(15, "Max 15 characters"),

  groupMid: yup
    .string()
    .max(15, "Max 15 characters"),

  // ── Address ─────────────────────────────────────────────────────────────────
  addressLine1: yup
    .string()
    .required("Address Line 1 is required")
    .max(40, "Max 40 characters"),

  addressLine2: yup.string().max(35, "Max 35 characters"),

  addressLine3: yup.string().max(35, "Max 35 characters"),

  city: yup
    .string()
    .required("City is required")
    .max(35, "Max 35 characters"),

  postCode: yup
    .string()
    .required("Post Code is required")
    .max(10, "Max 10 characters"),

  // ── Contact ─────────────────────────────────────────────────────────────────
  contactName: yup.string().max(35, "Max 35 characters"),

  mobileNo: mobileNoOptional(),

  emailId: yup
    .string()
    .email("Invalid email address")
    .max(30, "Max 30 characters")
    .nullable()
    .transform((v) => (v === "" ? null : v)),

  // ── Bank ────────────────────────────────────────────────────────────────────
  bankAccount: yup
    .string()
    .max(16, "Max 16 characters"),

  bankName: yup.string().max(100, "Max 100 characters"),

  ifscCode: yup.string().max(15, "Max 15 characters"),
});

export { merchantSchema, merchantSchemaStep1, merchantSchemaStep2 };
